// src/feed/useMyReaction.ts
//
// Realtime check for whether the current user has reacted to a
// given feed item. Used by the heart toggle to render filled vs
// outlined.
//
// Listens to /feed_items/{itemId}/reactions/{my_uid} — single doc,
// cheap.

import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { auth, db } from '../services/firebase';
import { ReactionType } from './types';

export interface UseMyReactionResult {
  reaction: ReactionType | null;
  loading: boolean;
}

export function useMyReaction(itemId: string): UseMyReactionResult {
  const [reaction, setReaction] = useState<ReactionType | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const me = auth.currentUser;
    if (!me) {
      setReaction(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    const ref = doc(db, 'feed_items', itemId, 'reactions', me.uid);
    const unsub = onSnapshot(
      ref,
      (snap) => {
        if (snap.exists()) {
          const data = snap.data() as any;
          setReaction((data.type as ReactionType) ?? 'heart');
        } else {
          setReaction(null);
        }
        setLoading(false);
      },
      (err) => {
        console.warn('useMyReaction listener error:', err);
        setLoading(false);
      }
    );
    return () => unsub();
  }, [itemId]);

  return { reaction, loading };
}
